// @flow
import * as React from 'react'

import { useInputStyles } from './styles'

export default class Styleguide extends React.Component<
  { children: (lib: any) => React.Node },
  { lib: any, ssrActive: boolean }
> {
  state = {
    lib: null,
    ssrActive: true
  }

  componentDidMount() {
    this.setState({
      ssrActive: false,
      lib: require('@ipex/voipex-styleguide')
    })
  }

  render() {
    const { ssrActive, lib } = this.state
    return !ssrActive ? this.props.children(lib) : null
  }
}

type InputProps = {
  id?: string,
  label?: string,
  wrapperProps?: any
}

const Input = ({ id, label, wrapperProps, ...props }: InputProps) => {
  const classes = useInputStyles()
  return (
    <Styleguide>
      {({ Input }) => {
        return (
          <div className={classes.inputWrapper} {...wrapperProps}>
            {label && <label id={`${id || 'input'}-label`}>{label}</label>}
            <Input id={id} {...props} />
          </div>
        )
      }}
    </Styleguide>
  )
}

const Button = (props: {}) => (
  <Styleguide>
    {({ Button }) => {
      return <Button {...props} />
    }}
  </Styleguide>
)

const Dropdown = (props: {}) => (
  <Styleguide>
    {({ Dropdown }) => {
      return <Dropdown {...props} />
    }}
  </Styleguide>
)

export { Button, Dropdown, Input }
